namespace $ { $mol_style_attach( "optimade/zero/zero.view.css",
 "[optimade_zero] {\n\tfont-family: 'Exo 2', 'Segoe UI',\n\t\tTahoma,\n\t\tGeneva,\n\t\tVerdana,\n\t\tsans-serif;\n}\n"
) }